// Module
var code = "<div> <top-menu></top-menu> <router-view></router-view> </div> ";
// Exports
module.exports = code;